import Calendar from "react-calendar";
import React, { useEffect, useState } from "react";
import {
    dateFormat,
    dateFormatDash,
    dateFormatDateTime,
    formatMonthYear,
    formatSelectedDate,
    formatTime,
    koreanWeekdays,
    ReservationStatusType,
    timeFormat,
    useFormInput,
} from "../../../utils";
// import { useGetDashboardQuery } from "../../../redux/scheduleApi";
// import { useGetCalendarDataMutation } from "../../../redux/reservationApi";
import { format, isSameDay, parseISO } from "date-fns";

export const DashBoardCalendar = ({ clientId }) => {
    const { formData, handleChange, setFormData } = useFormInput({
        selectedDate: new Date(),
        formattedDate: "",
    });
    const { selectedDate, formattedDate } = formData;

    const [selectedDateData, setSelectedDateData] = useState([]);

    const onChangeCalendar = (date) => {
        // const selectedData = calendarData?.data.filter((item) => isSameDay(parseISO(item.serviceHopeDate), date));
        // setFormData({
        //     selectedDate: date,
        //     formattedDate: format(date, "yyyy-MM-dd"),
        // });
        // setSelectedDateData(selectedData);
    };

    const getTileContent = ({ date, view }) => {
        // if (view === "month") {
        //     const count = calendarData?.data.filter((item) => isSameDay(parseISO(item.serviceHopeDate), date)).length;
        //     return count > 0 ? <div className="schedule_day-data">+{count}</div> : null;
        // }
        return null;
    };

    // useEffect(() => {
    //     onChangeCalendar(selectedDate);
    //     getCalendarData({
    //         clientId: clientId,
    //         month: selectedDate.getMonth() + 1,
    //     });
    // }, [clientId, selectedDate]);

    // const [getCalendarData, { data: calendarData, error: calendarError, isLoading: calendarLoading }] = useGetCalendarDataMutation();

    // useEffect(() => {
    //     console.log(calendarData);
    // }, [calendarData]);

    return (
        <>
            <section className="schedule-calendar" data-develop="false">
                <div className="section-content">
                    <div className="box-wrapper">
                        <div className="calendar">
                            <span className="selected-date">{formattedDate}</span>
                            <Calendar
                                locale="en-US"
                                formatShortWeekday={(locale, date) => koreanWeekdays[date.getDay()]}
                                formatMonthYear={formatMonthYear}
                                tileContent={getTileContent}
                                value={selectedDate}
                                onChange={onChangeCalendar}
                                // onActiveStartDateChange={(e) => {
                                //     getCalendarData({
                                //         clientId: clientId,
                                //         month: e.activeStartDate.getMonth() + 1,
                                //     });
                                // }}
                            />
                        </div>

                        <div className="calendar-detail">
                            <div className="section-content" style={{ marginTop: "0" }}>
                                <div className="schedule-detail" data-develop="false">
                                    <div className="schedule-head">
                                        <span className="head-tit">
                                            {dateFormat(selectedDate)}
                                            <span className="total">총 {selectedDateData?.length}개 예약</span>
                                        </span>
                                        <div className="head-etc">
                                            <span className="etc-item">
                                                점검 완료 <b>{selectedDateData?.filter((e) => e.reservationStatus === "FINISH").length}</b>
                                            </span>
                                            <span className="etc-item">
                                                작업 예정
                                                <b>
                                                    <em>{selectedDateData?.filter((e) => e.reservationStatus !== "FINISH").length}</em>
                                                </b>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="schedule-content">
                                        <div className="item-list">
                                            {selectedDateData?.length === 0 && (
                                                <div className={`item`}>
                                                    <span className="item-name"> 예약 없음 </span>
                                                </div>
                                            )}
                                            {selectedDateData?.map((item, index) => (
                                                <div
                                                    key={`bottom_item${index}`}
                                                    className={`item ${
                                                        item.reservationStatus === "FINISH"
                                                            ? "status-complete"
                                                            : item.reservationStatus === "CANCEL"
                                                            ? "status-canceled"
                                                            : ""
                                                    }`}
                                                >
                                                    <span className="item-cnt">{index + 1}</span>
                                                    <span className="item-time">{timeFormat(item.serviceHopeDate)}</span>
                                                    <span className="item-name">{item.contract.customerName}님</span>
                                                    <span className="item-status">
                                                        {ReservationStatusType.find((i) => i.value === item.reservationStatus).label}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
